/**
 * The interface-language switcher in the app bar (spec §8.23) `[M23]`.
 *
 * The choice goes to the reader's account, so it follows them to another browser or machine. Until
 * they choose, the select shows the language their browser asked for and nothing is stored.
 */
import { Languages } from "lucide-react";
import { useSetLanguage } from "../api/hooks";
import { LANGUAGES, LANGUAGE_NAMES, useI18n, useT } from "../i18n";

export function LanguageSwitcher() {
  const { language } = useI18n();
  const t = useT();
  const set = useSetLanguage();
  return (
    <label className="flex items-center gap-1.5 text-[13.5px] text-neutral-500" title={t("app.language")}>
      <Languages size={15} aria-hidden="true" />
      <span className="sr-only">{t("app.language")}</span>
      <select
        className="kss-control kss-field bg-transparent px-1.5 py-0.5 text-[13.5px]"
        value={language}
        disabled={set.isPending}
        data-testid="language-switcher"
        onChange={(e) => void set.mutateAsync(e.target.value)}
      >
        {LANGUAGES.map((l) => (
          <option key={l} value={l}>
            {LANGUAGE_NAMES[l]}
          </option>
        ))}
      </select>
    </label>
  );
}
